import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel">
        <div className="text-[11px] uppercase tracking-editorial text-[#C3B1C5]">◐ Payment Cancelled</div>
        <h1 className="font-serif-display text-[36px] mt-3 tracking-tight">No worries.</h1>
        <p className="mt-4 text-[14px] text-[#4A464A]/75">Your bag is still here — take your time.</p>
        <Link to="/looks" className="inline-block mt-10 px-6 py-3 text-[11px] uppercase tracking-editorial" style={{ background: "#4A464A", color: "#FDFBF7" }}>Back to the Looks</Link>
      </div>
    </div>
  );
}
